.kv{min-width:14rem;}